import { space } from './space';
import type { GridContainer } from './types';

export const gridContainer: GridContainer = {
  xs: space.s100,
  sm: space.s100,
  md: space.s250,
  lg: space.s250,
  xl: space.s250,
};
